module.exports = "data:image/gif;base64,R0lGODlhEAALAJEAAAAAAP///////wAAACH5BAEAAAIALAAAAAAQAAsAAAIUlI+ZoO0vGJxPHkujY1xj+FWZUwAAOw=="